<template>
    <div id="dra-modal-container">
        <BaseModal
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="title"
            :width="'40%'"
            height="auto"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK }
            ]"
            @Close="close"
        >
            <div id="dialog-body-contaniner">
                <b-row>
                    <b-col lg="4" md="4" sm="12">
                        <MdDateTime
                            :Label="$t('Shared.ServiceDate')"
                            :Model="editableItem.serviceDate"
                            @input="editableItem.serviceDate = $event"
                            :Id="'service-date'"
                            :Type="'date'"
                            :isRequired="false"
                            :isConfirm="false"
                            :ReadOnly="true"
                        >
                        </MdDateTime>
                    </b-col>
                    <b-col lg="8" md="8" sm="12">
                        <MdSelect
                            v-bind:Label="$tc('Shared.Therapist', 2)"
                            v-bind:Options="therapistList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="therapistModel"
                            v-bind:Multiple="false"
                            :Input="changeDropDownTherapist"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.Facility')"
                            v-bind:Options="facilitiesList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="facilityModel"
                            v-bind:Multiple="false"
                            :Input="changeDropDownFacility"
                        />
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <MdSelect
                            v-bind:Label="$t('dcsview.PofService')"
                            v-bind:Options="placeOfServicesList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="placeOfServiceModel"
                            v-bind:Multiple="false"
                            :Input="changeDropDownPlaceOfService"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="4" sm="12">
                        <MdSelect
                            :Label="$t('MdCurrentAppointment.StarTime')"
                            :Options="fillWithHoursList"
                            :FieldDescription="'description'"
                            :FieldCode="'code'"
                            :Model="timeFromModel"
                            :Multiple="false"
                            :Input="changeDropDownStartTime"
                        />
                    </b-col>
                    <b-col lg="4" md="4" sm="12">
                        <MdSelect
                            :Label="$t('MdCurrentAppointment.EndTime')"
                            :Options="fillWithHoursList"
                            :FieldDescription="'description'"
                            :FieldCode="'code'"
                            :Model="timeToModel"
                            :Multiple="false"
                            :Input="changeDropDownEndTime"
                        />
                    </b-col>
                </b-row>
            </div>
        </BaseModal>
    </div>
</template>

<script>
import Utils from '@/common/utils';
import moment from 'moment';

export default {
    name: 'DateRangeAttendanceModal',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        therapistList: {
            type: Array,
            default: () => []
        },
        facilitiesList: {
            type: Array,
            default: () => []
        },
        placeOfServicesList: {
            type: Array,
            default: () => []
        },
        noteOptions: {
            type: Object,
            default: () => {}
        }
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        },
        value(newVal) {
            this.editableItem = { ...newVal };
            this.isStartTimeValid = true;
            this.isEndTimeValid = true;
        },
        noteOptions() {
            this.fillWithHoursList = this.generateFillWithHoursList();
        }
    },
    data() {
        return {
            modalId: 'DateRangeAttendanceModal',
            emitCloseEvent: false,
            editableItem: { ...this.value },
            isStartTimeValid: true,
            isEndTimeValid: true,
            fillWithHoursList: []
        };
    },

    computed: {
        title() {
            return `${this.editableItem?.name}`;
        },
        therapistModel() {
            if (!Utils.isNullOrEmptyString(this.editableItem.therapistCode)) {
                const indexOf = this.therapistList.findIndex(
                    x => x.code === this.editableItem.therapistCode
                );

                if (indexOf !== -1) {
                    return this.therapistList[indexOf];
                }

                return this.editableItem.therapistCode;
            }

            return null;
        },
        facilityModel() {
            if (!Utils.isNullOrEmptyString(this.editableItem.facilityCode)) {
                const indexOf = this.facilitiesList.findIndex(x => {
                    return x.code.trim() === this.editableItem.facilityCode.trim();
                });

                if (indexOf !== -1) {
                    return this.facilitiesList[indexOf];
                }

                return this.editableItem.facilityCode;
            }

            return null;
        },
        placeOfServiceModel() {
            if (!Utils.isNullOrEmptyString(this.editableItem.posCode)) {
                const indexOf = this.placeOfServicesList.findIndex(
                    x => x.code === this.editableItem.posCode
                );

                if (indexOf !== -1) {
                    return this.placeOfServicesList[indexOf];
                }

                return this.editableItem.posCode;
            }
            return null;
        },
        timeFromModel() {
            if (!Utils.isNullOrEmptyString(this.editableItem.timeFrom)) {
                const fillWithHoursList = this.fillWithHoursList;
                const indexOf = fillWithHoursList.findIndex(
                    x => x.code === this.editableItem.timeFrom
                );

                console.log('timeFromModel', this.editableItem.timeFrom);
                if (indexOf !== -1) {
                    return fillWithHoursList[indexOf];
                }

                return this.editableItem.timeFrom;
            }

            return null;
        },
        timeToModel() {
            if (!Utils.isNullOrEmptyString(this.editableItem.timeTo)) {
                const fillWithHoursList = this.fillWithHoursList;
                const indexOf = fillWithHoursList.findIndex(
                    x => x.code === this.editableItem.timeTo
                );

                console.log('timeToModel', this.editableItem.timeFrom);
                if (indexOf !== -1) {
                    return fillWithHoursList[indexOf];
                }

                return this.editableItem.timeTo;
            }

            return null;
        }
    },

    methods: {
        getSubtitle(column) {
            return Utils.formatterDateToString(column.transDate);
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            if (this.validate()) {
                this.$emit('update:visible', false);
                this.$emit('ok', this.editableItem);
            } else {
                bvModalEvent.preventDefault();

                /*this.isValidDocument = this.isValid('docCode');
                this.isValidDate = this.isValid('expDate');
                this.isValidComment = this.isValid('comment');*/
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent = false;
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate() {
            return true;
        },

        changeDropDownTherapist(therapist) {
            this.editableItem.therapistCode = therapist ? therapist.code : null;
        },

        changeDropDownFacility(result) {
            this.editableItem.facilityCode = result ? result.code : null;
        },

        changeDropDownPlaceOfService(result) {
            this.editableItem.posCode = result ? result.code : null;
        },

        changeDropDownStartTime(value) {
            this.editableItem.timeFrom = value ? value.code : null;
        },

        changeDropDownEndTime(value) {
            this.editableItem.timeTo = value ? value.code : null;
        },

        generateFillWithHoursList() {
            const BASE = '1899-12-30';

            let present = this.noteOptions.startTime
                ? moment(`${BASE} ${moment(this.noteOptions.startTime).format('HH:mm')}`)
                : moment(`${BASE} 00:00`);

            let last = this.noteOptions.endTime
                ? moment(`${BASE} ${moment(this.noteOptions.endTime).format('HH:mm')}`)
                : moment(`${BASE} 23:59`);

            const result = [];

            while (present.isSameOrBefore(last)) {
                result.push({
                    code: present.format('YYYY-MM-DDTHH:mm:ss'),
                    description: present.format('h:mm A')
                });
                present.add(5, 'minutes');
            }

            return result;
        }
    },

    mounted() {
        this.fillWithHoursList = this.generateFillWithHoursList();
    }
};
</script>
